import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var DEPRECATED_SIZE_MAPPING = {
  normal: "md",
  small: "sm"
};
var DEFAULT_SIZE = "md";
var DEFAULT_COLOR = "text-darkest";
var SIZE_STYLES = {
  md: "text-xs",
  sm: "text-2xs"
};
var DEFAULT_SIZE_STYLES = SIZE_STYLES[DEFAULT_SIZE];
function getCorrectSize(size) {
  if (Object.keys(DEPRECATED_SIZE_MAPPING).includes(size)) {
    var mappedSize = DEPRECATED_SIZE_MAPPING[size];
    console.warn("DEPRECATION WARNING: value of property size: ".concat(size, " of Label is deprecated, please use ").concat(mappedSize));
    return mappedSize;
  } else {
    return size;
  }
}
var Label = function Label(_a) {
  var _b = _a.size,
    size = _b === void 0 ? DEFAULT_SIZE : _b,
    _c = _a.color,
    color = _c === void 0 ? DEFAULT_COLOR : _c,
    _d = _a.className,
    className = _d === void 0 ? "" : _d,
    children = _a.children;
  var sizeClass = SIZE_STYLES[getCorrectSize(size)] || DEFAULT_SIZE_STYLES;
  var LabelClassNames = classNames(["mx-xs", "p-xs", "font-bold", "rounded-base", "text-lightest", "inline-block", "whitespace-no-wrap", "whitespace-nowrap", color || DEFAULT_COLOR, sizeClass, "auto-qa-label", className]);
  return /*#__PURE__*/React.createElement("span", {
    className: LabelClassNames
  }, children);
};
Label.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["md", "sm"]),
  color: PropTypes.string,
  className: PropTypes.string
};

export { Label };
//# sourceMappingURL=index.es.js.map
